export const getCommunityImageUrl = (
    communityId?: string | null,
    imageName?: string | null,
): string => {
    if (!communityId || !imageName) {
        return "/fallback-community-image.png";
    }

    if (imageName.startsWith("http")) {
        return imageName;
    }

    const baseUrl = process.env.NEXT_PUBLIC_ASSETS_URL?.endsWith("/")
        ? process.env.NEXT_PUBLIC_ASSETS_URL.slice(0, -1)
        : process.env.NEXT_PUBLIC_ASSETS_URL;

    return `${baseUrl}/community/${communityId}/${imageName}`;
};
